<template>
  <div>
    <b-input-group class="mb-3">
      <b-form-input
        v-model="input_date"
        type="text"
        placeholder="DD/MM/YYYY"
        autocomplete="off"
        :required="required"
        :disabled="disabled"
      >
      </b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          v-model="pick_date"
          button-only
          right
          locale="vi-VN"
          start-weekday="1"
          aria-controls="ngaysinh-input"
          :disabled="disabled"
        >
        </b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: "MyDatePicker",
  props: ["value", "required", "disabled"],
  data() {
    return {
      pick_date: null,
    };
  },
  watch: {
    pick_date: function(newValue, oldValue) {
      if (newValue != null) {
        var date_split = newValue.split("-");
        this.input_date =
          date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      }
    },
    input_date: function(newValue, oldValue) {
      if (newValue != oldValue && this.checkValidInputDate(newValue)) {
        var date_split = newValue.split("/");
        // dd/MM/yyyy => yyyy-MM-dd
        this.pick_date =
          date_split[2] + "-" + date_split[1] + "-" + date_split[0];
      }
    }, //Update 02Oct2024: add method by tandn
  },
  computed: {
    input_date: {
      get: function() {
        if (this.value == null || this.value == "Invalid Date") return "";
        if (!this.value.includes("/") && this.value.length > 10) {
          return this.$convert_date_string(this.value);
        }
        return this.value;
      },
      set: function(modifiedValue) {
        this.$emit("input", modifiedValue);
      },
    },
  },
  methods: {
    checkValidInputDate(str) {
      var t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (t === null) return false;
      var d = parseInt(t[1]),
        m = parseInt(t[2], 10),
        y = parseInt(t[3], 10);
      //below should be more acurate algorithm
      if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
        return true;
      }
      return false;
    },
  },
};
</script>
